module.exports = __webpack_public_path__ + "static/img/bond01.5e3f320e.png";